import React from 'react';
import Navbar from '../components/Navbar';
import { Trophy } from 'lucide-react';

const LeaderboardPage: React.FC = () => {
  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-secondary-50 pb-8">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-secondary-900 mb-2">Leaderboard</h1>
            <p className="text-sm text-secondary-600">Top performing members of the federation</p>
          </div>
          <div className="card text-center py-16">
            <Trophy size={64} className="mx-auto mb-4 text-secondary-300" />
            <p className="text-secondary-500">Leaderboard page - TypeScript + Tailwind CSS</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaderboardPage;
